import { useEffect } from 'react';
import { useSubscriptionInternal } from './internal/use-subscription-internal';
export function useSubscription() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return useSubscriptionInternal(useEffect, args);
}
//# sourceMappingURL=use-subscription.js.map